export default "__VITE_ASSET__DuUj0M13__"